import React, { FC, useEffect, useState } from 'react';

import { LinearProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import styles from './ContextModelTagInfo.module.scss';
import { dataGridFocusStyles } from 'styles';
import { tagInfoColumns, TagInfoCustomToolbar } from './TagInfoTable/TagInfoTableDefinition';

interface ContextModelTagInfoProps {
  selectedNode: any
}

const ContextModelTagInfo: FC<ContextModelTagInfoProps> = (
  {
    selectedNode,
  }
) => {

  const [nodeAttributes, setNodeAttributes] = useState<any>([]);

  useEffect(() => {
    if (!selectedNode) {
      setNodeAttributes([]);
      return;
    }

    const attributesToShow = ["code", "name", "definition"];
    const rows = attributesToShow.map((attribute, index) => ({
      id: index,
      attribute: attribute,
      value: selectedNode[attribute] || 'N/A'
    }));

    setNodeAttributes(rows);

  }, [selectedNode]);

  return (
    <div
      className={styles.ContextModelTagInfo}
      data-testid="ContextModelTagInfo"
    >
      <DataGrid
        rows={nodeAttributes}
        columns={tagInfoColumns}
        slots={{
          loadingOverlay: LinearProgress,
          toolbar: () => TagInfoCustomToolbar(),
        }}
        // loading={isFetching}
        className="project-data-grid"
        // getRowId={row => row._id}
        sx={dataGridFocusStyles}
        // sx={{ ...dataGridFocusStyles, ...dataGridFontSizeStyles }}
        disableRowSelectionOnClick
        disableColumnMenu
      />
    </div>
  );
}

export default ContextModelTagInfo;
